import '../VtxRpsFrame.less';